import {
  clearWeeklyActivity,
  getWeeklyActivity,
} from "@/redux/slices/userSlices/optionsSlice";

import {useEffect} from "react";

import rejectImage from "@images/cards/user-rem.png";
import successImage from "@images/cards/user-set.png";
import activeImage from "@images/cards/user.png";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Spinner} from "@ui/general/Spinner";
import {WarningData} from "@ui/general/WarningData";
import {H3} from "@ui/titles/H3";
import CountUp from "react-countup";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const Statistic = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {current} = useSelector((state) => state.user.view);
  const {id} = useSelector((state) => state.common.candidate);
  const {weeklyActivity, status} = useSelector((state) => state.user.options);

  const userId = current?.id || id;

  const calculateDifference = (current, previous) => {
    return current - previous;
  };

  const statisticList = [
    {
      id: 0,
      icon: activeImage,
      title: t("overview_card.total_title"),
      total: weeklyActivity.total,
      totalChange: calculateDifference(
        weeklyActivity.past_week,
        weeklyActivity.previous_week,
      ),
    },
    {
      id: 1,
      icon: successImage,
      title: t("overview_card.success_title"),
      total: weeklyActivity.total_successful,
      totalChange: calculateDifference(
        weeklyActivity.past_week_successful,
        weeklyActivity.previous_week_successful,
      ),
    },
    {
      id: 2,
      icon: rejectImage,
      title: t("overview_card.reject_title"),
      total: weeklyActivity.total_unsuccessful,
      totalChange: calculateDifference(
        weeklyActivity.past_week_unsuccessful,
        weeklyActivity.previous_week_unsuccessful,
      ),
    },
  ];

  useEffect(() => {
    dispatch(getWeeklyActivity(userId));

    return () => {
      dispatch(clearWeeklyActivity());
    };
  }, [dispatch, userId]);

  return (
    <div className={styles.statistic}>
      <div className={styles.statisticHead}>
        <H3>{t("page.profile.statistic.title")}</H3>
      </div>

      <div className={styles.overviewList}>
        {status === "loading" ? (
          <Spinner />
        ) : status === "error" ? (
          <WarningData type={"error"} />
        ) : (
          <>
            {statisticList &&
              statisticList.map((item) => (
                <div key={item?.id}>
                  <BorderArticle>
                    <div className={styles.overviewItem}>
                      <img
                        src={item?.icon}
                        alt={"icon"}
                      />

                      <div className={styles.overviewItemContent}>
                        <RootDesc>
                          <b className={"font-[600] text-[var(--grey)]"}>
                            {item?.title}
                          </b>
                        </RootDesc>

                        <div className={styles.overviewItemBottom}>
                          <strong>
                            <CountUp
                              end={item?.total}
                              duration={4}
                            />
                          </strong>

                          <RootDesc>
                            <b
                              style={
                                item?.totalChange === 0
                                  ? {color: "var(--grey)"}
                                  : item?.totalChange > 0
                                    ? {color: "var(--green)"}
                                    : {color: "var(--red)"}
                              }
                              className={"font-[23rem]"}
                            >
                              <CountUp
                                end={item?.totalChange}
                                duration={4}
                              />
                            </b>
                            <br />
                            <span
                              className={"text-[var(--grey)]"}
                              dangerouslySetInnerHTML={{
                                __html: t("overview_card.subtitle"),
                              }}
                            />
                          </RootDesc>
                        </div>
                      </div>
                    </div>
                  </BorderArticle>
                </div>
              ))}
          </>
        )}
      </div>
    </div>
  );
};
